import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { MessageCard } from "@/components/MessageCard";
import { Skeleton } from "@/components/ui/skeleton";
import { Button } from "@/components/ui/button";
import { Heart } from "lucide-react";

export default function Favoritos() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      navigate("/login");
      return;
    }
    api
      .get("/me/favorites")
      .then((res) => setMessages(res.data.messages || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [user, authLoading, navigate]);

  if (authLoading || (!user && loading)) {
    return (
      <div className="mx-auto w-full max-w-6xl px-4 py-12 sm:px-6">
        <Skeleton className="h-10 w-64" />
        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {[...Array(3)].map((_, i) => (
            <Skeleton key={i} className="h-56 w-full rounded-[var(--radius)]" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-6xl px-4 py-10 sm:px-6 sm:py-14 lg:px-8">
      <div className="mb-8 flex items-center gap-2">
        <Heart className="h-6 w-6 text-primary" />
        <h1 className="font-serif text-3xl font-semibold sm:text-4xl">Mis favoritos</h1>
      </div>

      {loading ? (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {[...Array(3)].map((_, i) => (
            <Skeleton key={i} className="h-56 w-full rounded-[var(--radius)]" />
          ))}
        </div>
      ) : messages.length === 0 ? (
        <div className="rounded-[var(--radius)] border border-border bg-card p-10 text-center" data-testid="favoritos-empty-state">
          <p className="font-serif text-xl font-semibold">Aún no has guardado mensajes</p>
          <p className="mt-2 text-sm text-muted-foreground">
            Empieza por el Mensaje de Hoy. Los mensajes que guardes aparecerán aquí para acompañarte cuando los necesites.
          </p>
          <Button asChild className="mt-6">
            <Link to="/" data-testid="favoritos-go-home-button">Ver el Mensaje de Hoy</Link>
          </Button>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3" data-testid="favoritos-grid">
          {messages.map((m) => (
            <MessageCard key={m.id} message={m} />
          ))}
        </div>
      )}
    </div>
  );
}
